import { Component, Input, OnChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConferenceRow, conferenceDetailText, conferenceSummary, conferenceText } from '../../utils/dashboard-conference';

// Conferência (spec §11): uma linha com o total do período e o link para o ranking completo.
// Substitui o pódio. `checkers` null/undefined = ainda carregando.
@Component({
  selector: 'app-dashboard-conference',
  standalone: true,
  imports: [RouterModule],
  host: { class: 'col-12 col-lg-6' },
  styles: [
    `
      :host {
        min-width: 0;
      }
    `,
  ],
  template: `
    <div class="card h-100">
      <div class="card-header">
        <h5 class="card-title mb-0">Conferência</h5>
      </div>
      <div class="card-body">
        @if (text === null) {
          <div class="placeholder-glow" aria-busy="true"><span class="placeholder rounded col-10 d-block"></span></div>
        } @else {
          <p class="mb-2" data-conference-text>{{ text }}</p>
          @if (detail) {
            <p class="mb-2 small text-muted" data-conference-detail>{{ detail }}</p>
          }
          <a routerLink="/conferencia/ranking" class="small" data-ranking-link>Ver ranking</a>
        }
      </div>
    </div>
  `,
})
export class DashboardConferenceComponent implements OnChanges {
  @Input() checkers?: ConferenceRow[] | null;

  text: string | null = null;
  /** "Acerto de primeira 97% · 2 reconferências". */
  detail: string | null = null;

  ngOnChanges(): void {
    const summary = this.checkers ? conferenceSummary(this.checkers) : null;
    this.text = summary ? conferenceText(summary) : null;
    this.detail = summary ? conferenceDetailText(summary) : null;
  }
}
